import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["option"];
import { memo } from 'react';
import { CampaignOptionLabel } from './CampaignOptionLabel';
import { jsx as _jsx } from "react/jsx-runtime";
function CampaignSelectedValueBase(_ref) {
  var _option$colorHex;
  let {
      option
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(CampaignOptionLabel, Object.assign({}, rest, {
    text: option.text || option.buttonText || '',
    campaignColor: (_option$colorHex = option.colorHex) !== null && _option$colorHex !== void 0 ? _option$colorHex : undefined,
    truncate: true
  }));
}
export const CampaignSelectedValue = /*#__PURE__*/memo(CampaignSelectedValueBase);